import type { CustomerStripeCustomer } from '@barboxx/models/types';

import { api } from '../../api';
import { throwIfBadResponse } from '../../utils';

const customerRootPath = 'stripe/customer';

export function createCustomerSheet() {
    return throwIfBadResponse(
        api.post<CustomerStripeCustomer.CreateCustomerSheetResponse>(
            `${customerRootPath}/customer-sheet`
        )
    );
}
